
import locomotiveScrollMixin from '@/mixins/locomotiveScrollMixin';
import philosophyQuery from "@/apollo/queries/pages/philosophy";
import previewModeMixin from '@/mixins/previewModeMixin';

export default {
  name: 'philosophy',
  colorMode: 'light',
  mixins: [locomotiveScrollMixin, previewModeMixin],
  data() {
    return {
      disableToggleNav: false,
      animationInProgress: false,
      activeIndex: 0,
      philosophy: null,
      viewportWidth: 0,
    };
  },
  async asyncData({app, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    const response = await app.apolloProvider.defaultClient.query({
      query: philosophyQuery,
      variables: {
        locale: app.i18n.locale,
      },
    }).catch((err) => {
      console.log(JSON.stringify(err, null, 2));
    })

    return {
      philosophy: response.data.philosophy,
      previewMode
    }
  },
  computed: {
    isMobileTimeline() {
      let locoIsMobile = false;

      if (this.locoScroll) {
        locoIsMobile = this.locoScroll.options.isMobile || this.locoScroll.options.isTablet
      }

      return this.viewportWidth < 768 || this.$device.isMobileOrTablet || locoIsMobile
    },
  },
  mounted() {
    this.updateViewportWidth();
    window.addEventListener('resize', this.updateViewportWidth);

    this.$nextTick(() => {
      // Call setScrollTriggerAnimation only if viewport width is above 768px (tablet)
      if (!this.isMobileTimeline) {
        this.triggerDesktopView();
      }
    });
  },
  watch: {
    animationInProgress(inProgres) {
      if (inProgres) {
        this.locoScroll.stop();
      } else {
        this.locoScroll.start();
      }
    }
  },
  methods: {
    triggerDesktopView() {
      this.setScrollTriggerAnimation();

      // Update custom cursor position
      this.locoScroll.on('scroll', () => {
        this.$refs.CustomCursor.$emit('loco-scroll-update');
      });
    },
    setScrollTriggerAnimation() {
      let sections = this.$gsap.utils.toArray(".panel");

      sections.forEach((panel, i) => {
        this.$ScrollTrigger.create({
          trigger: panel,
          // scrub: 1,
          onEnter: () => {
            this.disableToggleNav = true;
            if (!this.animationInProgress) {
              const instance = {direction: 'down'}
              this.handleScroll(instance)

              this.animationInProgress = true;
              this.goToSection(i + 1);
            }
          },
          onUpdate: (context) => {
            // If we leave the first section directly after entering it
            if (this.disableToggleNav && context.direction === -1 && this.activeIndex === 0) {
              this.disableToggleNav = false;
            }
          },
        });

        this.$ScrollTrigger.create({
          trigger: panel,
          start: "bottom bottom",
          end: "bottom top",
          scrub: 1,
          onEnterBack: () => {
            if (!this.animationInProgress) {
              const instance = {direction: 'up'}
              this.handleScroll(instance);
              // If we go to the first section re-enable the menu toggle functionality
              if (i === 0) {
                this.disableToggleNav = false;
              }
              this.goToSection(i + 1)
              this.activeIndex = i;
            }
          }
        });
      });
    },
    goToSection(i) {
      this.animationInProgress = true;
      this.activeIndex = i - 1;

      if (!this.isMobileTimeline) {
        this.locoScroll.scrollTo(this.$refs.processWrapper, {
          offset: i * innerHeight,
          duration: 600,
          callback: () => {
            this.animationInProgress = false;
          },
          disableLerp: true,
          easing: [0.25, 0.00, 0.35, 1.00],
          autoKill: false,  // Prevent scroll animation from being interrupted
        });
      } else {
        this.locoScroll.scrollTo(".timeline-item-" + (this.activeIndex + 1), {
          duration: 600,
          callback: () => {
            this.animationInProgress = false;
          },
          disableLerp: true,
          easing: [0.25, 0.00, 0.35, 1.00],
          autoKill: false,  // Prevent scroll animation from being interrupted
        });
      }
    },
    updateViewportWidth() {
      this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    },
  }
}
